




































import { ChainModule } from '@/store/modules/chain.module'
import Vue from 'vue'
import Component from 'vue-class-component'
import { getModule } from 'vuex-module-decorators'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { IOnboardingMilestoneTemplate } from '@zunta/configurations'
import MilestonesBlock from '../components/MilestonesBlock.vue'
import Icon from '@/components/Icon.vue'
import Card from '@/components/Card.vue'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import AddEditTemplateModal from '../components/AddEditTemplateModal.vue'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')

@Component({
  components: {
    InputV2,
    Card,
    LoaderWrapper,
    MilestonesBlock,
    AddEditTemplateModal,
    Icon
  }
})
export default class ChainsMilestones extends Vue {
  chainModuleInstance: ChainModule = getModule(ChainModule, this.$store)
  isLoading: boolean = true
  searchMilestone: string = ''
  isWantAddTemplate: boolean = false

  get milestoneTemplates () {
    return this.$store.state.chain.onboardingTemplates
  }

  get displayTemplate () {
    return this.milestoneTemplates.filter((template: IOnboardingMilestoneTemplate) => {
      if (!template.parent) {
        return true
      }
      return new RegExp(`${this.searchMilestone}`, 'i').test(template.milestone)
    })
  }

  get milestonesList () {
    const group: { [k: string]: IOnboardingMilestoneTemplate[] } = groupBy(this.displayTemplate, (template: IOnboardingMilestoneTemplate) => {
      return template.parent
    })
    const items: any[] = []
    const map: any = {}
    Object.keys(group).forEach((key) => {
      const parent: IOnboardingMilestoneTemplate = this.displayTemplate.find((template: IOnboardingMilestoneTemplate) => template.id === +key)
      if (parent) {
        map[parent.id] = true
        const item = {
          parent,
          subTemplates: sortBy(group[key], (template: IOnboardingMilestoneTemplate) => template.order)
        }
        items.push(item)
      }
    })
    if ((group['null'] || []).length !== Object.keys(map).length) {
      (group['null'] || []).forEach((template: IOnboardingMilestoneTemplate) => {
        if (!map[template.id]) {
          items.push({
            parent: template,
            subTemplates: []
          })
        }
      })
    }
    return sortBy(items, (item: any) => item.parent.order)
  }

  mounted () {
    this.fetchTemplates()
  }

  async fetchTemplates () {
    this.isLoading = true
    await this.chainModuleInstance.fetchOnboardingTemplates()
    this.isLoading = false
  }

  async addTemplate (name: string) {
    await this.chainModuleInstance.createOnboardingTemplate({
      name
    })
    this.isWantAddTemplate = false
  }
}
